module.exports = __webpack_public_path__ + "static/media/ShearNVBug.73f3bd99.jpg";